<section class="installed-wrapper">
  <h6 translate class="title">INTEGRATIONS.{{integratedPlatformType}}.INSTALLED_TEXT_TITLE</h6>
  <p translate class="buttons-description" *ngIf="allowsImport()">INTEGRATIONS.{{integratedPlatformType}}.INSTALLED_TEXT_DESCRIPTION</p>
  <div class="buttons-wrapper" *ngIf="allowsImport()">
    <button
      (click)="skip()"
      mat-raised-button
      type="button"
      color="info-full"
      [disabled]="installationInProgress"
      class="install-button">
      {{'INTEGRATIONS.SKIP' | translate}}
    </button>

    <button
      (click)="import()"
      mat-raised-button
      type="button"
      [disabled]="installationInProgress"
      color="primary-full"
      class="install-button">
      {{'INTEGRATIONS.IMPORT' | translate}}
    </button>
  </div>

  <img src="/assets/img/channels/integration-installed.svg"/>
</section>
